import React, { Component } from "react";
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";
import slugify from "underscore.string/slugify";
import forEach from "../../utils/forEach";
import {
  MenuOptionWithChildren,
  IconWrapper,
  Content,
  Sublink,
  Dot,
  InlineDot,
} from "./styles/sidebar-content-styles";

class OptionWithDropdown extends Component {
  componentDidMount() {
    const dropdownIcons = document.querySelectorAll(".dropdown-icon");
    const dropdowns = document.querySelectorAll(".dropdown-content");

    // dropdowns behavior
    forEach(dropdownIcons, (item) => {
      item.addEventListener("mouseover", () => {
        forEach(dropdowns, (element) => {
          element.classList.remove("show");
        });
        item.nextSibling.classList.toggle("show");
      });
    });

    // hide dropdown on mouseleave
    forEach(dropdowns, (item, index) => {
      item.addEventListener("mouseleave", () => {
        dropdowns[index].classList.remove("show");
      });
    });

    document.addEventListener("click", (e) => {
      if (!e.target.classList.contains("dropdown-icon")) {
        forEach(dropdowns, (item) => {
          item.classList.remove("show");
        });
      }
    });
  }

  render() {
    const { menuItem } = this.props;
    const { label, className, icons, sublinks } = menuItem;
    const hasNotifcations = sublinks.some((sublink) => sublink.notification);

    return (
      <MenuOptionWithChildren
        className={`${className || ""} ${slugify(label)}`}
      >
        <IconWrapper>
          {icons.map((icon) => (
            <Icon
              key={icon.name}
              name={icon.name}
              className={icon.className || "dropdown-icon"}
            />
          ))}
          <Content dropdown className="dropdown-content">
            {label}
            {sublinks.map((sublink) => (
              <Sublink
                key={sublink.label}
                href={sublink.href}
                className={`${sublink.className || ""} ${slugify(
                  label
                )}__${slugify(sublink.label)}`}
              >
                {sublink.icons.map((icon) => (
                  <Icon key={icon.name} name={icon.name} />
                ))}
                {sublink.label}
                {sublink.notification && <InlineDot />}
              </Sublink>
            ))}
          </Content>
          <Dot
            className={`${slugify(label)}-dot ${
              !hasNotifcations ? "hidden" : ""
            }`}
          />
        </IconWrapper>
      </MenuOptionWithChildren>
    );
  }
}

OptionWithDropdown.propTypes = {
  menuItem: PropTypes.shape({
    label: PropTypes.string,
    className: PropTypes.string,
    notification: PropTypes.string,
    icons: PropTypes.arrayOf(
      PropTypes.shape({ name: PropTypes.string, className: PropTypes.string })
    ),
    sublinks: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        notification: PropTypes.string,
        icons: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string,
            className: PropTypes.string,
          })
        ),
      })
    ),
  }).isRequired,
};

export default OptionWithDropdown;
